// extracted by mini-css-extract-plugin
export default {"departments":"vF-z","departmentHeading":"wF-z","departmentSection":"xF-z","departmentName":"yF-z","departmentLink":"zF-z","expandIcon":"AF-z"};